import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class RecTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "settingColumn", title: "Einstellungen" },
        { name: "optionColumn", title: "Empfohlene" },
        { name: "descriptionColumn", title: "Beschreibung" }
      ],
      rows: [
        { settingColumn: 'Video Encoder', optionColumn: 'Auto', descriptionColumn: 'Der Videobrenner. Shinobi wird versuchen, die für Sie beste Option zu wählen, wenn Sie Auto wählen. Für manuelle Auswahl:  RTSP-Kameras nehmen in der Regel Kopien entgegen. MJPEG-Kameras nehmen die libx264 auf.' },
        { settingColumn: 'Audio Encoder', optionColumn: 'No Audio', descriptionColumn: 'RTSP-Kameras verwenden in der Regel aac. MJPEG-Kameras müssen auf Kein Audio eingestellt sein.' },
        { settingColumn: 'Segment Length', optionColumn: '2', descriptionColumn: 'Stellen Sie dies auf 2 für einen Puffer von ~5 Sekunden ein.' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

RecTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(RecTable)